module.exports = __webpack_public_path__ + "static/media/whatsapp.9a142180.svg";